import { importProvidersFrom } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { DialogService } from './dialog.service';

export const provideDialog = () => {
  return [importProvidersFrom(MatDialogModule), DialogService];
};
